import { render, staticRenderFns } from "./ProjectsInProgressCard.vue?vue&type=template&id=06805633&scoped=true"
import script from "./ProjectsInProgressCard.vue?vue&type=script&lang=ts"
export * from "./ProjectsInProgressCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsInProgressCard.vue?vue&type=style&index=0&id=06805633&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06805633",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06805633')) {
      api.createRecord('06805633', component.options)
    } else {
      api.reload('06805633', component.options)
    }
    module.hot.accept("./ProjectsInProgressCard.vue?vue&type=template&id=06805633&scoped=true", function () {
      api.rerender('06805633', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/ProjectsInProgressCard.vue"
export default component.exports